import {
  Item,
  Link as RadixNavigationLink,
  NavigationMenuLinkProps,
} from "@radix-ui/react-navigation-menu";
import { Link, useLocation } from "react-router";

import { cn } from "@/utils/classes";

interface NavigationLinkProps extends Omit<NavigationMenuLinkProps, "href"> {
  disabled?: boolean;
  href: string;
}

function NavigationLink({
  disabled,
  href,
  className,
  children,
  ...props
}: NavigationLinkProps) {
  const location = useLocation();

  return (
    <Item
      // When disabled, we render a span, not a link!
      asChild={!disabled}
      className={cn(
        "gap-2xs border-grayscale-x-light p-xs text-grayscale-dark hover:border-grayscale focus-visible:border-grayscale flex items-center rounded-md border bg-white transition-colors",
        disabled &&
          "border-grayscale-xx-light bg-grayscale-xx-light text-grayscale hover:border-grayscale-xx-light pointer-events-none",
        "data-[active]:border-primary-light data-[active]:text-primary-light",
        className
      )}
    >
      {disabled ? (
        <span>{children}</span>
      ) : (
        <RadixNavigationLink
          asChild
          {...props}
          active={location.pathname.includes(href)}
        >
          <Link to={href}>{children}</Link>
        </RadixNavigationLink>
      )}
    </Item>
  );
}

export default NavigationLink;
